import { useQuery } from "react-query";
import { AdminJobDetailResponse } from "../../../../models/Job";
import {
  KandidatResponse,
  StatusKandidatResponse,
} from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllStatusKandidatKey = "all-status-kandidat-key";

export async function fetchAllStatusKandidat(): Promise<
  StatusKandidatResponse[]
> {
  const res = await ApiClient.get(`/AllStatusKandidat`);
  return res.data;
}

export default function useFetchAllStatusKandidat() {
  return useQuery(
    [fetchAllStatusKandidatKey],
    queryWrapper(fetchAllStatusKandidat)
  );
}
